import React, { Component } from "react";
import { Col, Input, Row } from "reactstrap";
import { kpiBasedType } from "../../../../utils/constants";
import { getStatesByCountryCode } from "../../../../utils/states";
import { getCountries } from "../../../../utils/countries";
import TooltipDefinition from "../../../../components/UI/TooltipDefinition/TooltipDefinition";
// import { Tooltip } from 'reactstrap';
// import KPITooltip from './KPITooltip';
import Select from "react-select";
import Toggle from "react-toggle";

import "react-select/dist/react-select.css";
import "./KPIRecord.css";
export default class KPIRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kpiList: this.props.kpiList,
      countriesOptions: getCountries(),
      statesOptions: [],
      tooltipOpen: false,
      startAge: 0,
      endAge: 0,
      isDiversity: [],
    };
  }

  componentDidMount() {
    // let ageArr = []
    // for(var x=0; x<101;x++){
    //   ageArr.push({id:x, name:x})
    // }
    // // console.log(ageArr)
    // if(ageArr.length>0){
    //   this.setState((prevState) => ({
    //     startAge:[prevState.startAge, ...ageArr],
    //     endAge:[prevState.endAge, ...ageArr]
    //   }))
    // }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  renderGenderOption = option => {
    return option.disabled ? (
      <div className="select-gender-disable">{option.name}</div>
    ) : (
      <div className="gender-option">{option.name}</div>
    );
  };

  renderCountryOption = option => {
    return option.disabled ? (
      <div className="select-gender-disable">{option.name}</div>
    ) : (
      <div className="gender-option">{option.name}</div>
    );
  };

  renderKPIOption = option => {
    let target = `${option.code}${this.props.index}`;
    return (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.name}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  renderOccupationOption = option => {
    let target = `${option.code}${this.props.index}`;
    // console.log('tar---', target)
    return option.name === "All" ? (
      <div className="w-100 kpi-option">{option.name}</div>
    ) : (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.name}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  renderEthnicityOption = option => {
    // console.log(option)
    // let target = `${option.definition}${this.props.index}`;
    return option.values && option.values.length > 0 ? (
      <div className="field-option">{option.name}</div>
    ) : (
      <div className="select-field-disable">{option.name}</div>
    );

    // return (
    //   option.name==='All' ?
    //   <div className="w-100 kpi-option" >{option.name}</div>
    //    :<TooltipDefinition
    //     target={target}
    //     definition={option.definition}
    //     name={option.name}
    //     type="light"
    //     place="left"
    //     delayShow={500}
    //   />)
  };

  renderJobCategoryOption = option => {
    let target = `${option.code}${this.props.index}`;
    return option.name === "All" ? (
      <div className="w-100 kpi-option">{option.name}</div>
    ) : (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.name}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  renderFieldOptions = option => {
    // console.log(option)
    let target = `${option.id}${this.props.name}`;

    // let target = `${option.definition}${this.props.index}`;
    if (option.values && option.values.length > 0) {
      return (
        <TooltipDefinition
          target={target}
          definition={option.definition}
          name={option.name}
          type="light"
          place="left"
          delayShow={500}
        />
      );
      // <div className="field-option">{option.name}</div>
    } else {
      return <div className="select-field-disable">{option.name}</div>;
    }
    // return (option.values && option.values.length>0) ? (<div className="field-option">{option.name}</div>): (<div className="select-field-disable">{option.name}</div>)
  };


  handleUseLatestDateChange = () => {
    let {startDate, useLatestDataAvailable} = this.state;
    this.setState({ previewOrContinue:true,useLatestDataAvailable: !this.state.useLatestDataAvailable, endDate: null, error: false });
    this.getAgreegateKPIRecordData(startDate,null,!useLatestDataAvailable);
  }

  renderNumbers = () => {
    // console.log(this.props)
    let ageArr = [];
    // let x = this.props.kpi.ageStart?this.props.kpi.ageStart:0
    for (let x = 18; x < 101; x++) {
      ageArr.push({ id: x, name: x });
    }
    return ageArr;
  };

  
  optionsCheck = options => {
    options.filter(e => e.id !== null && e.id !== undefined);
  };

  kpiRecordCheck = (type, values) => {
    // console.log(s)
    // if(type=='kpi'){
    //   this.props.onKpiSelect(selectedKPI, index)
    // } else if(type='gender'){
    //   this.props.onGenderSelect(selectedGender, index)
    // } else if('ethnicity'){
    //   this.props.onEthnicitySelect(selectedEthnicity, index)
    // }
  };

  render() {
    let {
      kpi,
      label,
      index,
      kpiList,
      orgMapping,
      kpiType,
      ageRange,
      isCopied,
      isChartLocked
    } = this.props;
    let { countriesOptions, statesOptions } = this.state;
    let { country, state } = kpi.selectedLocation;
    let {
      sexualOrientationOptions,
      veteranOptions,
      disabilityOptions,
      ethnicityOptions,
      religionOptions,
    } = orgMapping;
    let disableStatesSelect = true;
    // console.log(orgMapping,'-org----', kpi)
    let ageArr = [];
    for (var x = 0; x < 101; x++) {
      ageArr.push({ id: x, name: x });
    }

    if (country && country.code === "US") {
      statesOptions = getStatesByCountryCode("US");
      statesOptions = statesOptions.map(state => {
        return { id: state.abbreviation, name: state.name };
      });
      disableStatesSelect = false;
    }
    countriesOptions = countriesOptions.map(country => {
      if (country.code === "US" || country.code === "ALL") {
        return country;
      } else {
        return { ...country, disabled: true };
      }
    });

    let isSurvey = kpiType === kpiBasedType.surveyBased ? true : false;


    let applicantKPIs = ['HRT-2','HRT-4','HRT-1','HRT-3','HRT-5','HRT-8','HRT-8a']

    let allowedTenureKPIs = ['REP-1',"COMP-3","COMP-1","HRT-6","HRT-7","GRO-1"]

    return (
      <div>
        <Row>
          <Col sm="2" md="2" className="d-flex justify-content-end">
            <div className="chartLabel align-self-center">
              Select KPI {label}
            </div>
          </Col>

          <div className="col-md-10 paddingLeftNone">
            <Col sm="3" md="3" className="inlineBlock paddingRight5">
              <div className="mapping-select-name ">KPI</div>
              <Select
                name="kpi-select"
                placeholder={"Select KPI..."}
                value={kpi.selectedKPI}
                optionRenderer={this.renderKPIOption}
                isOpen={true}
                onChange={
                  selectedKPI => this.props.onKpiSelect(selectedKPI, index)
                  // this.kpiRecordCheck('kpi',{selectedKPI, index})
                }
                options={kpiList.sort(function (a, b) {
                  if (a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  return 0;
                })}
                valueKey="id"
                labelKey="name"
                disabled={this.props.isOwner || isChartLocked}
              />
            </Col>
            {kpi.selected &&
              (kpi.gender || kpiType === kpiBasedType.empDataBased) && (
                <Col
                  className={`${
                    isSurvey ? "col-md-4" : "col-md-2"
                  } inlineBlock paddingRightLeft10`}
                >
                  <div className="mapping-select-name ">
                    {isSurvey ? "Diversity" : "Gender"}
                  </div>
                  <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.gender}
                    optionRenderer={this.renderGenderOption}
                    onChange={
                      selectedGender =>
                        this.props.onGenderSelect(selectedGender, index)
                      // this.kpiRecordCheck('gender' ,{selectedGender, index})
                    }
                    options={kpi.genderOptions.filter(e => e.id !== "ALL")}
                    disabled={!kpi.enableGender || this.props.isOwner || isChartLocked}
                    valueKey="id"
                    labelKey="name"
                  />
                </Col>
              )}
            {kpi.selected && kpiType === kpiBasedType.empDataBased && (
              <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                <div className="mapping-select-name ">Ethnicity/Race</div>
                <Select
                  name="kpi-select"
                  placeholder={"Select..."}
                  value={kpi.ethnicity}
                  optionRenderer={this.renderFieldOptions}
                  onChange={
                    selectedEthnicity =>
                      this.props.onEthnicitySelect(selectedEthnicity, index)
                    // this.kpiRecordCheck('ethnicity' ,{selectedEthnicity, index})
                  }
                  options={orgMapping.ethnicityOptions.filter(
                    e => e.id !== null && e.id !== undefined
                  )}
                  disabled={!kpi.enableEthnicity || this.props.isOwner || isChartLocked}
                  valueKey="id"
                  labelKey="name"
                />
              </Col>
            )}

            {kpi.selected &&
              sexualOrientationOptions &&
              kpiType === kpiBasedType.empDataBased && (
                <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                  <div className="mapping-select-name ">Sexual Orientation</div>
                  <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.sexualOrientation}
                    optionRenderer={this.renderFieldOptions}
                    onChange={selectedField =>
                      this.props.onFieldSelect(
                        selectedField,
                        "sexualOrientation",
                        index
                      )
                    }
                    options={orgMapping.sexualOrientationOptions.filter(
                      e => e.id !== null && e.id !== undefined
                    )}
                    disabled={
                      !kpi.enableSexualOrientation || this.props.isOwner || isChartLocked
                    }
                    valueKey="id"
                    labelKey="name"
                  />
                </Col>
              )}
            {kpi.selected &&
              religionOptions &&
              kpiType === kpiBasedType.empDataBased && (
                <Col
                  sm="2"
                  md="2"
                  className="inlineBlock paddingRightLeft10 bottomMargin10"
                >
                  <div className="mapping-select-name ">Religion</div>
                  <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.religion}
                    optionRenderer={this.renderFieldOptions}
                    onChange={selectedField =>
                      this.props.onFieldSelect(selectedField, "religion", index)
                    }
                    options={orgMapping.religionOptions.filter(
                      e => e.id !== null && e.id !== undefined
                    )}
                    disabled={!kpi.enableReligion || this.props.isOwner || isChartLocked}
                    valueKey="id"
                    labelKey="name"
                  />
                </Col>
              )}
            <div className="inlineBlock ageContainer col-sm-6 col-md-3 ">
              {kpi.selected && kpiType === kpiBasedType.empDataBased && (
                <Col
                  sm="6"
                  md="6"
                  className="inlineBlock noLeftPadding paddingRight5"
                >
                  <div className="mapping-select-name ">From Age</div>
                  <Select
                    name="kpi-select ageEnd"
                    placeholder={"Select..."}
                    value={kpi.ageStart}
                    onChange={selectedField =>
                      this.props.onFieldSelect(selectedField, "ageStart", index)
                    }
                    options={this.renderNumbers()}
                    valueKey="id"
                    labelKey="name"
                    disabled={isChartLocked}
                  />
                </Col>
              )}
              {kpi.selected && kpiType === kpiBasedType.empDataBased && (
                <Col
                  sm="6"
                  md="6"
                  className="inlineBlock paddingRightLeft10 noRightPadding paddingLeft5"
                >
                  <div className="mapping-select-name ">To Age</div>
                  <Select
                    name="kpi-select ageEnd"
                    placeholder={"Select..."}
                    value={kpi.ageEnd}
                    onChange={selectedField =>
                      this.props.onFieldSelect(selectedField, "ageEnd", index)
                    }
                    options={this.renderNumbers()}
                    valueKey="id"
                    labelKey="name"
                    disabled={isChartLocked}
                  />
                </Col>
              )}
            </div>

            {kpi.selected &&
              veteranOptions &&
              kpiType === kpiBasedType.empDataBased && (
                <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                  <div className="mapping-select-name ">Veteran Status</div>
                  <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.veteran}
                    optionRenderer={this.renderFieldOptions}
                    onChange={selectedField =>
                      this.props.onFieldSelect(selectedField, "veteran", index)
                    }
                    options={orgMapping.veteranOptions.filter(
                      e => e.id !== null && e.id !== undefined
                    )}
                    disabled={!kpi.enableVeteran || this.props.isOwner || isChartLocked}
                    valueKey="id"
                    labelKey="name"
              
                  />
                </Col>
              )}
            {kpi.selected &&
              disabilityOptions &&
              kpiType === kpiBasedType.empDataBased && (
                <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                  <div className="mapping-select-name ">Disability</div>
                  <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.disability}
                    optionRenderer={this.renderFieldOptions}
                    onChange={selectedField =>
                      this.props.onFieldSelect(
                        selectedField,
                        "disability",
                        index
                      )
                    }
                    options={orgMapping.disabilityOptions.filter(
                      e => e.id !== null && e.id !== undefined
                    )}
                    disabled={!kpi.enableDisability || this.props.isOwner || isChartLocked}
                    valueKey="id"
                    labelKey="name"
                  />
                </Col>
              )}
            {kpi.selected && kpiType === kpiBasedType.empDataBased && (
              <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                <div className="mapping-select-name ">Occupation</div>
                <Select
                  name="kpi-select"
                  placeholder={"Select..."}
                  value={kpi.occupation}
                  optionRenderer={this.renderOccupationOption}
                  onChange={selectedOccupation =>
                    this.props.onOccupationSelect(selectedOccupation, index)
                  }
                  options={orgMapping.occupationOptions.filter(
                    e => e.code !== "ALL"
                  )}
                  disabled={!kpi.enableOccupation || this.props.isOwner || isChartLocked}
                  valueKey="id"
                  labelKey="name"
                />
              </Col>
            )}
            {kpi.selected && kpiType === kpiBasedType.empDataBased && (
              <Col sm="2" md="2" className="inlineBlock paddingRightLeft10">
                <div className="mapping-select-name ">Job Category</div>
                <Select
                  name="kpi-select"
                  placeholder={"Select..."}
                  value={kpi.seniority}
                  optionRenderer={this.renderJobCategoryOption}
                  onChange={selectedSenoirity =>
                    this.props.onSenoiritySelect(selectedSenoirity, index)
                  }
                  options={orgMapping.seniorityOptions.filter(
                    e => e.code !== "ALL"
                  )}
                  disabled={!kpi.enableSeniority || this.props.isOwner || isChartLocked}
                  valueKey="id"
                  labelKey="name"
                />
              </Col>
            )}




{kpi.selected && 
         allowedTenureKPIs.indexOf(kpi.selectedKPI.code) > -1 &&
              kpiType === kpiBasedType.empDataBased && (
                <Col sm="9" md="8" className="inlineBlock mt-3 kpi-tenure">
                  <div className="mapping-select-name ">Include Average Employee Tenure</div>
                 
                  <Toggle defaultChecked={kpi.tenure} 
                    // icons={false} 
                    onChange={ selectedField =>   this.props.onFieldSelect(  selectedField.target.checked, "tenure", index) } 
                  />
                  <span>{kpi.tenure? 'True':'False'}</span>
                  {/* <Select
                    name="kpi-select"
                    placeholder={"Select..."}
                    value={kpi.tenure}
                    optionRenderer={[
                      {id: true, name: 'True'},
                      {id: false, name: 'False'},
                    ]}
                    onChange={selectedField =>
                      this.props.onFieldSelect(selectedField, "veteran", index)
                    }
                    options={orgMapping.veteranOptions.filter(
                      e => e.id !== null && e.id !== undefined
                    )}
                    disabled={!kpi.enableVeteran || this.props.isOwner || isChartLocked}
                    valueKey="id"
                    labelKey="name"
              
                  /> */}
                </Col>
              )}

          </div>
        </Row>
        {kpi.selected && kpiType === kpiBasedType.empDataBased && (
          <Row className={kpi.selected ? "mt30" : ""}>
            {/* <Col sm={{ size: 2, offset: 2 }} md={{ size: 2, offset: 2 }}>
       <div className="mapping-select-name">Country</div>
          <Select
            name="kpi-country-select"
            placeholder={"Select..."}
            value={country}
            onChange={(country) => this.props.onCountrySelect(country, index)}
            options={countriesOptions}
            optionRenderer={this.renderCountryOption}
            isClearable={false}
            clearable={false}
            backspaceRemovesValue={true}
            valueKey='code'
            labelKey='name'
            />
        </Col> */}
            {/* <Col sm="2" md="2">
          <div className="mapping-select-name">State</div>
          <Select name="kpi-state-select" 
            placeholder={"Select..."} 
            value={state} 
            onChange={selectedState => this.props.onStatesSelect(selectedState, index)} 
            options={statesOptions} 
            valueKey="id" 
            labelKey="name" 
            isClearable={false}
            clearable={false}
            disabled={disableStatesSelect} 
            />
        </Col> */}
          </Row>
        )}
      </div>
    );
  }
}
